<template>
  <div class="homecontainer _homecontainer">
     <div class="banner_m">
      <GoodBriefInfo
        v-for="(item, index) in m_bannerList"
        :key="index"
        :imgsrc="item"
      />
    </div>
    <div class="banner_pc">
      <GoodBriefInfo
        v-for="(item, index) in bannerList"
        :key="index"
        :imgsrc="item"
      />
    </div>
   
    <Title HomeTitle="分享探险 · SHARE THE ADVENTURE" />
    <!-- 合作伙伴 -->
    <div class="bottom">
      <div class="home_tit">合作伙伴</div>
      <div class="home_tits">PARTNERS</div>
      <div class="bottom_list">
        <div class="item" v-for="item in partnerList" :key="item.id">
          <!-- 表头 -->
          <div class="item_tit">
            <span>{{ $store.state.chinese ? item.name : item.e_name }}</span>
          </div>
          <div class="line"></div>
          <!-- 表单 -->
          <ul>
            <li v-show="index<=4||show||ismobile"  v-for="(i,index) in item.childList" :key="i.id">
              {{ $store.state.chinese ? i.name : i.e_name }}
            </li>
          </ul>
        </div>
      </div>
      <button @click="changeShow" class="bottom_btn">{{ show?'隐藏':"查看更多合作伙伴"}}</button>
    </div>

  </div>
</template>

<script>
import GoodBriefInfo from "./subcomponents/GoodBriefInfo";
import Title from "@/components/comcomponents/Title";
import { getBanner, partner } from "@/api/home";

export default {
  name: "",
  data() {
    return {
      // 图片列表
      bannerList: [],
      // 移动端图片列表
      m_bannerList: [],
      // 合作伙伴
      partnerList: [],
      show:false,
      ismobile:false

    };
  },
  components: {
    GoodBriefInfo,
    Title,
  },
  methods: {
    changeShow(){
      this.show=!this.show
    },
    async banner(data) {
      const res = await getBanner(data);
      if (res.code === 200) {
        return res.result;
      }
    },
    async partner() {
      const res = await partner();
      if (res.code === 200) {
        this.partnerList = res.result;
      }
    },
  },
  created() {
    this.banner({ is_mobile: 1 }).then((res) => {
      this.m_bannerList = res;
    });
    this.banner({ type: 1 }).then((res) => (this.bannerList = res));
    this.partner();
    let width=document.body.clientWidth
    if(width<768){
      this.ismobile=true
    }
  },
};
</script>

<style lang="less" scoped>

@keyframes scroll {
  from {
    top: 200px;
    opacity: 0;
  }
  25% {
    top: 150px;
    opacity: 0.3;
  }
  50% {
    top: 100px;
    opacity: 0.5;
  }
  75% {
    top: 50px;
    opacity: 0.8;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
@media only screen and (min-width: 768px) {
  .homecontainer {
    animation: scroll 1s linear forwards;
    width: 100%;
    position: relative;
    min-width: 1200px;
    .banner_m {
      display: none;
    }
    font-size: 1vw;
    .subdiv {
      width: 100%;
      display: flex;
      justify-content: space-around;
      font-size: 0.5em;
      .left {
        width: 48%;
        height: 100%;
        font-size: 0.8em;
      }
      .right {
        width: 48%;
        height: 100%;
        font-size: 0.8em;
      }
    }
    .bottom {
      background: #f0f2f5;
      padding-bottom: 60px;
      .home_tit {
        width: 155px;
        font-size: 36px;
        font-family: 'PingFang SC';
        font-weight: bold;
        color: #1a213f;
        margin: 0 auto;
      }
      .home_tits {
        width: 256px;
        margin: 0 auto;
        font-size: 30px;
        font-family:'PingFang SC';
        font-weight: 400;
        color: #004993;
        line-height: 25px;
        opacity: 0.15;
        margin-bottom: 50px;
      }
      .bottom_list {
        width: 90%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
          .item {
        flex: 1;
        .item_tit {
          font-size: 17px;
          font-family: 'PingFang SC' ,'Microsoft YaHei';
          font-weight: bold;
          color: #1a213f;
          line-height: 48px;
          text-align: left;
          margin-bottom: 40px;
          span {
            border-bottom: 2px solid #004993;
            padding-bottom: 16px;
          }
        }
        ul {
          li {
            font-size: 15px;
            width: 100%;
            font-family: 'PingFang SC', 'Microsoft YaHei';
            font-weight: 400;
            color: #1a213f;
            line-height: 35px;
            text-align: left;
          }
        }
      }
      }
    
      .bottom_btn{
      margin-top: 80px;
      width: 300px;
      height: 32px;
      color: white;
      border: 1px solid #1a213f;
      background-color: #0f1e3d;
      cursor: pointer;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  ._homecontainer {
    animation: scroll 3s linear forwards;
    .banner_pc {
      display: none;
    }
    font-size: 1vw;
    .bottom {
      background: #f0f2f5;
      padding-bottom: 60px;
      .home_tit {
        width: 155px;
        font-size: 28px;
        font-family: "PingFang SC", 'Microsoft YaHei';
        font-weight: bold;
        color: #1a213f;
        margin: 0 auto;
      }
      .home_tits {
        width: 256px;
        margin: 0 auto;
        font-size: 24px;
        font-family: 'PingFang SC', 'FS Albert';
        font-weight: 400;
        color: #004993;
        line-height: 25px;
        opacity: 0.15;
        margin-bottom: 40px;
      }
      .bottom_list {
        width: 100%;
        padding: 0 20px;
        margin: 0 auto;
      }
      .item {
        .item_tit {
          font-size: .5rem;
          font-family: 'PingFang SC', 'Microsoft YaHei';
          font-weight: bold;
          color: #1a213f;
          line-height: 40px;
          text-align: left;
          padding: 8px 0;
        }
        .line {
          width: 100%;
          height: 0.06rem;
          background: #004993;
        }
        ul {
          padding: 18px 0;
          li {
            font-size: 0.4rem;
            display: inline-block;
            padding-right: 20px;
            font-family: "PingFang SC",'Microsoft YaHei';
            font-weight: 400;
            color: #1a213f;
            line-height: 1.25rem;
            text-align: left;
          }
        }
      }
      .bottom_btn{
        display: none;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/Home.vue